import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ashmtlab',
  templateUrl: './ashmtlab.component.html',
  styleUrls: ['./ashmtlab.component.scss']
})
export class AshmtlabComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
